import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';

import { filterChange,
        toggleSwitch } from '../../actions/index';

import { _ } from '../../functions/translator';
import { arraysHaveAnyMatch } from '../../functions/utils';
import { FilterActions, ToggleActions } from '../../constants/constants';

class StagesDropdown extends React.Component{

    handleStageChange = (event) => {
        let stageIds = event.target.value;
        this.props.filterChange(FilterActions.STAGES, stageIds);
        this.props.filterChange(FilterActions.CARD_CATEGORIES, []);
        this.props.filterChange(FilterActions.PROTOCOLGROUPS, []);
        this.props.filterChange(FilterActions.PROTOCOLS, []);
        this.filterLevelsSelected(stageIds);        
    };

    hasAStageAppartmentMatch(stageIds) {
        const stagesLevelsData = Object.values(this.props.levelsData).filter(levelData => stageIds.includes(levelData.attributes.stage_id));
        const stageLevelIds = stagesLevelsData.map(levelData => levelData.id);
        const levelIdsWithAppartments = Object.keys(this.props.matches.levels_appartments).map(levelId => parseInt(levelId));
        if (levelIdsWithAppartments.length && !stageIds.length) {
            return true;
        }
        return arraysHaveAnyMatch(stageLevelIds, levelIdsWithAppartments);
    }

    handleSelected = (stagesSelected) => {
        if (stagesSelected.length === 0) {
            return _('Etapas');
        } else {
            let stageNames = []
            for (const stageId of stagesSelected) {
                let stageData = this.props.stagesData[stageId.toString()]
                stageNames.push(stageData.attributes.name)
            }
            return stageNames.join(', ')
        }
    }

    filterLevelsSelected(stageIds) {
        let levelIdsSelected = this.props.levelIds.filter((levelId) => {
            let levelData = this.props.levelsData[levelId];
            let stageId = levelData ? levelData.attributes.stage_id : null;
            return stageIds.includes(stageId);
        });
        const levelsHasChanged = levelIdsSelected.length !== this.props.levelIds.length;
        if (levelsHasChanged) {
            this.props.filterChange(FilterActions.LEVELS, levelIdsSelected);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.stageIds !== prevProps.stageIds
            || this.props.matches !== prevProps.matches) {
            if (!this.props.matches.levels_appartments) return;
            const stagesWithAppartmentsSelected = this.hasAStageAppartmentMatch(this.props.stageIds);
            this.props.toggleSwitch(ToggleActions.SHOW_APPARTMENT_FILTER, stagesWithAppartmentsSelected);
            if (!stagesWithAppartmentsSelected) {
                this.props.filterChange(FilterActions.APPARTMENTS, []);
            }
        }
    }

    render() {
        let stagesList = []
        for (const [id, stage] of Object.entries(this.props.stagesData)) {
            stagesList.push(
            <MenuItem value={stage.id} key={id}>
                <Checkbox color="primary" checked={this.props.stageIds.includes(stage.id)} />
                {stage.attributes.name}
            </MenuItem>
            )
        }

        return(
            <div>
                <Select
                value={this.props.stageIds}
                multiple={true}
                displayEmpty={true}
                renderValue={this.handleSelected}
                onChange={this.handleStageChange}
                MenuProps={{
                    PaperProps: {
                        style: {
                          maxHeight: 300,
                          top: '0px',
                          position: 'fixed',
                        },
                    },
                    getContentAnchorEl: null,
                }}>
                {stagesList}
                </Select>
            </div>
        );
    } 
}

function mapStateToProps( state ){
    return {
        stageIds   : state.filters.stageIds,
        stagesData : state.projectData.stages,
        levelIds   : state.filters.levelIds,
        levelsData : state.projectData.levels,
        matches    : state.matches
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        filterChange     : filterChange,
        toggleSwitch : toggleSwitch
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(StagesDropdown);